// Re-exports the markdown-to-DOM renderer as a project-registered function so
// any page/component can reach it via `el.call('applyMarkdownToElement', ...)`
// — the mandated cross-package access path for `@symbo-ls/*` shared code (a
// raw import gets frank-stubbed at platform-serialization time; see the
// comment above TicketDetailModal.js's renderMarkdown for the full
// rationale). Same pattern as resolveScope.js.
//
// Root cause this file fixes (EDITOR-COLLAPSE-1, tickets/sonnet.md): the
// function itself lived ONLY in components/MarkdownPreview.js, so it was
// merged into `context.components`, never `context.methods` /
// `context.functions` / `context.utils` — the three buckets `el.call`
// actually searches (see smbls/packages/element/src/methods.js
// warnUnresolvedCall). Every `el.call('applyMarkdownToElement', ...)` site
// across the workspace (tickets' TicketDetailModal, chat's ThreadPanel via
// functions/renderMarkdown.js, marketplace's MarketplaceDetailMarkdownBody,
// files' FilesViewer, documents' Editor) was silently returning `undefined`
// and rendering nothing — confirmed live: a ticket body/steps-to-reproduce/
// expected-result saved as `<p>...</p>` (anything NOT matching tickets'
// narrow `_HTML_TAG_RE` whitelist) took the markdown path, called this
// unregistered function, got a no-op, and rendered as an empty box even
// though the record held real content. A sibling field whose content
// happened to be wrapped in a whitelisted tag (`<ul><li>...</li></ul>`)
// rendered fine — same code path, only the bucket lookup differed.
//
// Purely additive: components/MarkdownPreview.js is untouched, so every
// existing `import { applyMarkdownToElement } from
// '@symbo-ls/workspace-shared/components/MarkdownPreview.js'` consumer
// (chat's functions/renderMarkdown.js) keeps working unchanged.
// `highlightMarkdownRefs` rides along for the same reason. It is the
// ##ticket / @@event / +doc card pass on its own, for surfaces that render the
// markdown body through a reactive `children:` factory instead of through
// applyMarkdownToElement's imperative innerHTML write (chat's MessageList and
// ThreadPanel — see the CHAT-STALE-BUBBLE note there).
export {
  applyMarkdownToElement,
  markdownToChildren,
  highlightMarkdownRefs
} from '../components/MarkdownPreview.js'
